<template>
    <div class="breadcrumb-wrap">
        <Breadcrumb>
            <BreadcrumbItem
                v-for="breadcrumbItem in breadcrumbPath"
                :key="breadcrumbItem.name"
                :to="breadcrumbItem.path ? breadcrumbItem.path : ''"
            >{{breadcrumbItem.title}}</BreadcrumbItem>
        </Breadcrumb>
    </div>
</template>

<script>
    export default {
        props: {
            breadcrumbPath: {
                type: Array
            }
        }
    }
</script>

<style lang="scss">
    .breadcrumb-wrap{
        margin-left: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/breadcrumb-path/breadcrumb.vue